import { InfoOutlined } from '@mui/icons-material';
import { Tooltip, Typography } from '@mui/material';

export const ApprovedDomainsInfoTooltip = () => {
  return (
    <Tooltip
      arrow
      placement="right"
      title={
        <Typography variant="caption">
          To add or remove domains, please reach out to Enterpret team via
          Slack/email.
        </Typography>
      }
    >
      <InfoOutlined fontSize="small" sx={{ color: 'text.secondary' }} />
    </Tooltip>
  );
};
